import { RexDateTime } from "../Dates/RexDateTime";
import { TServiceResult } from "./TServiceResult";

export class Smoke
{
    SmokeID: string = "";
    UserID: string = "";
    Tenant: string = "";
    Description: string = "";
    Date: RexDateTime | Date = new RexDateTime(0);
    Weather: string = "";
    BuriedWood: string = "";
    FloatWood: string = "";
    Charcoal: string = "";
    SmokerPrep: string = "";
}

export type ServiceSmokes = TServiceResult<Smoke[]>;

export const EmptyServiceSmokes: ServiceSmokes =
{
    TheValue: null,
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}
